// Разбор адреса Telegram-группы: сотрудники вставляют в поля ссылку из Telegram
// («Копировать ссылку»), а не голый id. Зеркало серверного App\Services\Notification\TelegramTarget —
// бэкенд разбирает и валидирует те же значения ещё раз, здесь это нужно, чтобы
// подсказать ошибку сразу и разложить ссылку по двум полям.
//
// t.me/c/<internal>/<thread>/<msg> → chat_id = -100<internal>, тема = <thread>
// t.me/<username>/<thread>/<msg>   → chat_id = @username, тема = <thread>
// t.me/<username>/<msg>            → ссылка на сообщение, темы в ней нет

const USERNAME_RE = /^[A-Za-z][A-Za-z0-9_]{3,31}$/

// Разобрать ссылку. Возвращает { chat_id, thread_id } (null, если не распознано).
export function parseTelegramLink(raw) {
	const result = { chat_id: null, thread_id: null }
	let value = String(raw || '').trim()

	value = value.replace(/^https?:\/\//i, '')
	const domainMatch = value.match(/^(?:www\.)?(?:t\.me|telegram\.me|telegram\.dog)\/(.*)$/i)

	if (!domainMatch) {
		// Обрывок ссылки без домена: 4400513197/1
		const tail = value.match(/^(\d{5,20})\/(\d{1,10})(?:\/\d{1,10})?$/)
		if (tail) {
			result.chat_id = '-100' + tail[1]
			result.thread_id = Number(tail[2])
		}
		return result
	}

	const parts = domainMatch[1].split(/[?#]/)[0].split('/').filter(p => p !== '')
	if (parts.length === 0) return result

	// Приватная супергруппа
	if (parts[0] === 'c') {
		if (!/^\d+$/.test(parts[1] || '')) return result
		result.chat_id = '-100' + parts[1]
		if (/^\d+$/.test(parts[2] || '')) result.thread_id = Number(parts[2])
		return result
	}

	// Публичная группа/канал
	if (!USERNAME_RE.test(parts[0])) return result
	result.chat_id = '@' + parts[0]
	// Тема есть только в ссылке вида /<username>/<thread>/<msg>
	if (/^\d+$/.test(parts[1] || '') && /^\d+$/.test(parts[2] || '')) {
		result.thread_id = Number(parts[1])
	}
	return result
}

export function parseChatId(raw) {
	const value = String(raw || '').trim()
	if (!value) return null

	const link = parseTelegramLink(value)
	if (link.chat_id) return link.chat_id

	if (!/^\d+$/.test(value) && USERNAME_RE.test(value.replace(/^@/, ''))) {
		return '@' + value.replace(/^@/, '')
	}
	if (/^-?\d{5,20}$/.test(value)) return value

	return null
}

export function parseThreadId(raw) {
	const value = String(raw || '').trim()
	if (!value) return null

	const link = parseTelegramLink(value)
	if (link.thread_id) return link.thread_id

	if (/^\d{1,10}$/.test(value)) return Number(value)

	return null
}

// Проверить пару перед отправкой на сервер.
// Возвращает { ok, error } — error это ключ перевода.
export function validateTelegramTarget(chatId, threadId, rawThread) {
	if (!chatId) return { ok: false, error: 'tg_chat_id_invalid' }

	// Частая ошибка: chat_id скопировали в оба поля — такая отправка падает целиком.
	// Сверяем сырой ввод: как номер темы он не разбирается, а сказать нужно про совпадение
	const rawThreadValue = String(rawThread || '').trim()
	if (rawThreadValue !== '' && rawThreadValue.replace(/^-/, '') === String(chatId).replace(/^[-@]/, '')) {
		return { ok: false, error: 'tg_thread_id_equals_chat' }
	}

	if (rawThreadValue !== '' && !threadId) {
		return { ok: false, error: 'tg_thread_id_invalid' }
	}

	if (threadId && threadId < 1) {
		return { ok: false, error: 'tg_thread_id_invalid' }
	}

	return { ok: true, error: null }
}
